import { UserCheck, Check, Clock, Ticket } from "lucide-react";

export default function AdminStats({ stats }) {
  if (!stats) return null;

  return (
    <>
      {/* Stats Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <StatCard 
          icon={<Ticket className="w-4 h-4 text-[#FFD700]" />}
          label="Biljettköp"
          value={stats.total_referrals}
          testId="total-referrals-card"
        />
        <StatCard 
          icon={<UserCheck className="w-4 h-4 text-[#FFD700]" />}
          label="Ambassadörer"
          value={stats.total_ambassadors}
          testId="total-ambassadors-card"
        />
        <StatCard 
          icon={<Check className="w-4 h-4 text-green-500" />}
          label="Godkända"
          value={stats.approved_ambassadors}
          valueColor="text-green-500"
          testId="approved-ambassadors-card"
        />
        <StatCard 
          icon={<Clock className="w-4 h-4 text-yellow-500" />}
          label="Väntar"
          value={stats.pending_ambassadors}
          valueColor="text-yellow-500"
          testId="pending-ambassadors-card"
        />
      </div>

      {/* Referrals by Ambassador */}
      {stats.referrals_by_ambassador && stats.referrals_by_ambassador.length > 0 && (
        <div className="bg-[#0A0A0A] border border-[#222] p-4 md:p-6 mb-8">
          <h3 className="text-xs font-bold uppercase tracking-widest text-[#FFD700] mb-4">
            Biljettköp per ambassadör
          </h3>
          <div className="flex flex-wrap gap-3">
            {stats.referrals_by_ambassador.map((item) => (
              <div key={item.ambassador} className="bg-[#1A1A1A] px-4 py-2 rounded">
                <span className="text-white font-medium">{item.ambassador}:</span>
                <span className="text-[#FFD700] font-bold ml-2">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function StatCard({ icon, label, value, valueColor = "text-white", testId }) {
  return (
    <div className="bg-[#0A0A0A] border border-[#222] p-4 md:p-6" data-testid={testId}>
      <div className="flex items-center gap-2 mb-2">
        {icon}
        <span className="text-xs font-bold uppercase tracking-widest text-gray-500">{label}</span>
      </div>
      <p className={`font-heading text-3xl ${valueColor}`}>{value}</p>
    </div>
  );
}
